/* MIRA — lightweight scroll reveal observer */
(function () {
  if (!("IntersectionObserver" in window)) {
    document.querySelectorAll(".mira__reveal").forEach(function (el) { el.classList.add("is-visible"); });
    return;
  }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) {
        e.target.classList.add("is-visible");
        io.unobserve(e.target);
      }
    });
  }, { threshold: 0.12, rootMargin: "0px 0px -60px 0px" });

  function init() {
    document.querySelectorAll(".mira__reveal:not(.is-visible)").forEach(function (el) { io.observe(el); });
  }
  if (document.readyState !== "loading") init();
  else document.addEventListener("DOMContentLoaded", init);
  document.addEventListener("shopify:section:load", init);
})();
